/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.banner-grid-article {
  @apply w-full h-auto grid gap-x-12px font-poppins;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto auto;
}
.banner-grid-article-container.pt-xsmall,
.banner-grid-article-container.pt-small,
.banner-grid-article-container.pt-medium,
.banner-grid-article-container.pt-large {
  @apply pt-0 !important;
}

.banner-grid-article-col-1 {
  @apply w-full h-full;
}

.banner-grid-article-col-2 {
  @apply w-full h-full;
}

.banner-grid-article .banner-grid-article-content {
  @apply w-full h-full rounded-[12px] flex flex-col justify-center items-start gap-[24px] p-40px;
}

.banner-grid-article .banner-grid-article-content .banner-grid-article-content-type {
  @apply w-full h-auto font-poppins text-0 md:text-1 font-medium;
}

.banner-grid-article .banner-grid-article-content .banner-grid-article-content-title {
  @apply w-full h-auto font-poppins text-3 sm:text-4 md:text-5 lg:text-6 font-semibold;
}

.banner-grid-article .banner-grid-article-content .banner-grid-article-content-byline {
  @apply w-full h-auto font-poppins -text-1 md:text-0 ;
}

.banner-grid-article .banner-grid-article-content .banner-grid-article-content-byline p {
  @apply inline;
}


.banner-grid-article .banner-grid-article-asset-wrapper {
  @apply w-full h-auto rounded-[12px] max-h-full aspect-video;
}

.banner-grid-article .banner-grid-article-asset-wrapper .banner-grid-article-asset {
  @apply w-full h-full max-h-full rounded-[12px] object-cover;
}

.banner-grid-article .banner-grid-article-tags-wrapper {
  @apply w-full h-auto flex flex-wrap justify-start items-center gap-4px px-32px py-16px bg-ui-gray-6 rounded-[12px] mt-12px;
}

.banner-grid-article .banner-grid-article-tags-wrapper .banner-grid-article-tag {
  @apply w-fit h-auto p-8px border border-ui-gray-4 rounded-[4px] text-ui-gray-2 -text-1 md:text-0 hover:border-medium-blue transition-colors hover:text-ui-gray-1;
}

@media(max-width: 767px) {
  .banner-grid-article {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
}

/* Animate in */@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1, .overlay2 {
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.banner-grid-article-container.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0.15s;
  }
  
  .banner-grid-article-container.animate .overlay2 {
    animation-name: fade-in;
    animation-delay: 0s;
  }

@media (min-width: 1000px) {
  .banner-grid-article-container.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0s;
  }
  
  .banner-grid-article-container.animate .overlay2 {
    animation-name: fade-in;
    animation-delay: 0.15s;
  }

}


.banner-grid-article-container.animate.content-right .overlay1 {
  animation-name: fade-in;
  animation-delay: 0.15s;
}

.banner-grid-article-container.animate.content-right .overlay2 {
  animation-name: fade-in;
  animation-delay: 0s;
}